import Api from '@/services/langApi'
import { Validator } from 'vee-validate'
import de from 'iview/dist/locale/de-DE'
import deJson from '../data/de.json'
import deValid from 'vee-validate/dist/locale/de'
import en from 'iview/dist/locale/en-US'
import enValid from 'vee-validate/dist/locale/en'
import es from 'iview/dist/locale/es-ES'
import esValid from 'vee-validate/dist/locale/es'
import fr from 'iview/dist/locale/fr-FR'
import frValid from 'vee-validate/dist/locale/fr'
import it from 'iview/dist/locale/it-IT'
import itValid from 'vee-validate/dist/locale/it'
import se from 'iview/dist/locale/sv-SE'

Validator.localize('de', deValid)
Validator.localize('en', enValid)
Validator.localize('fr', frValid)
Validator.localize('es', esValid)
Validator.localize('it', itValid)

const api = new Api()

const calenderLangs = {
  en: en,
  de: de,
  fr: fr,
  it: it,
  es: es,
  se: se
}

const LanguageService = class LanguageService {
  constructor (locale = null, languages) {
    this.translations = deJson
    if (!locale) {
      locale = navigator.language.substr(0, 2)
    }
    this.languages = languages
    this.setLocale(locale)
    Validator.localize(locale)
  }

  async loadLanguage (locale = null) {
    try {
      const response = await api.get('inquiries/lang/' + locale)
      return Promise.resolve(JSON.parse(response.data))
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async setLocale (locale) {
    if (!(locale in this.languages)) {
      locale = 'en'
    }

    this.translations = await this.loadLanguage(locale)

    try {
    } catch (error) {
      const message = 'An error occurred while loading translations (' + this.languages[locale] + ')'
      return Promise.reject(message)
    }

    let calMessages = {}
    let calLocale = null
    if (locale in calenderLangs) {
      calMessages = calenderLangs[locale]
      calLocale = locale
    } else {
      calMessages = calenderLangs['en']
      calLocale = 'en'
    }

    Validator.localize(calLocale)

    const messages = Object.assign(this.translations, calMessages)
    return Promise.resolve({
      calLocale: calLocale,
      locale: locale,
      messages: messages
    })
  }
}

export default LanguageService
